export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8855.41f7d218.jpg";